import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';

import chrome from '../img/app.png'
import desktop from '../img/desktop.png'
import './dnd.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowMaximize, faGlobe, faDesktop } from '@fortawesome/free-solid-svg-icons' 


export default memo(({ data }) => {

  const designerIconStyle = {
    backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', borderRadius:'20px', padding:'5px', marginLeft:'10px'
}

    var app = faGlobe
    if (data.appType == "desktop") {app = faDesktop}    

    return (
    <div className="designnode">
      <Handle
        type="target"
        position="top"
        // onConnect={(params) => console.log('handle onConnect', params)}
      />
      {/* <img  draggable={false} src={app} width='50' height='50'></img> */}
      <FontAwesomeIcon style={{margin:'10px'}} icon={app} style={designerIconStyle} size='2x'/>


      <div className="appcard">
      
        <div class="row">

          <h4 >{data.appShortName }</h4> 
          <div className="verticalline"></div>
          <h4 className="seconds">{data.timeSpent + ' seconds'}</h4> 
        </div>
      
      </div>
      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );
});